export default __webpack_public_path__ + "static/media/logo.954b1ac7.svg";